import { Controller } from "stimulus";

const DISMISS_STORAGE_KEY_PREFIX = 'complianceProfileNoticeDismissedAt'
const DISMISS_DURATION_MS = 24 * 60 * 60 * 1000

export default class extends Controller {
  static values = {
    complianceQuestionsUrl: String,
    jwtToken: String,
    userId: String,
    companyId: String
  }

  connect() {
    if (this.element.closest('.compliance-profile-notice-clone-container')) return

    this.checkAndShowToast()
  }

  get dismissStorageKey() {
    return `${DISMISS_STORAGE_KEY_PREFIX}:${this.userIdValue}:${this.companyIdValue}`
  }

  async checkAndShowToast() {
    if (this.isDismissedRecently()) return

    const hasUnansweredQuestions = await this.fetchHasUnansweredQuestions()
    if (!hasUnansweredQuestions) return

    this.updateComplianceProfileToast = Toastify({
      duration: -1,
      node: this.element,
      className: 'compliance-profile-notice-clone-container',
      style: { background: 'transparent', padding: 0, cursor: 'inherit' }
    })
    this.updateComplianceProfileToast.showToast()
  }

  async fetchHasUnansweredQuestions() {
    try {
      const response = await fetch(this.complianceQuestionsUrlValue, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.jwtTokenValue}`
        }
      })

      if (!response.ok) return false

      const data = await response.json()
      const questions = data.questions || []
      return questions.some(q => q.userAnswer === null || q.userAnswer === undefined)
    } catch (_error) {
      return false
    }
  }

  isDismissedRecently() {
    try {
      const dismissedAt = localStorage.getItem(this.dismissStorageKey)
      if (!dismissedAt) return false

      const dismissedTime = new Date(dismissedAt).getTime()
      const now = Date.now()
      return (now - dismissedTime) < DISMISS_DURATION_MS
    } catch (_error) {
      return false
    }
  }

  closeUpdateComplianceProfileToast() {
    try {
      localStorage.setItem(this.dismissStorageKey, new Date().toISOString())
    } catch (_error) {
      // localStorage may be disabled
    }
    this.updateComplianceProfileToast.hideToast()
  }
}
